import React from 'react';
import { RotateCcw } from 'lucide-react';

const AuditLogTab = ({ auditLogs, rollbackConfig, formatDate }) => {
  return (
    <>
      <h3 style={{ fontSize: '1.125rem', fontWeight: '600', marginBottom: '1.5rem' }}>Änderungsverlauf</h3>
      {auditLogs.length === 0 ? (
        <p style={{ color: '#666' }}>Keine Änderungen vorhanden</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {auditLogs.map((log, index) => (
            <div key={log.id || index} style={{ padding: '1rem', background: '#F9F9F9', borderRadius: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <p style={{ fontWeight: '600' }}>Version {log.config_version}</p>
                <p style={{ fontSize: '0.875rem', color: '#666' }}>
                  {formatDate(log.timestamp)} - {log.user}
                </p>
              </div>
              <button onClick={() => rollbackConfig(log.config_version)} className="btn-secondary" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <RotateCcw size={16} /> Wiederherstellen
              </button>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default AuditLogTab;
